import { render, staticRenderFns } from "./comprobantes.vue?vue&type=template&id=3521c390&"
import script from "./comprobantes.vue?vue&type=script&lang=js&"
export * from "./comprobantes.vue?vue&type=script&lang=js&"
import style0 from "./comprobantes.vue?vue&type=style&index=0&id=3521c390&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports